import React, { useRef, useState, useEffect } from "react";
import {
  FormGroup,
  Button,
  TextArea,
  Classes,
  RadioGroup,
  Radio,
  InputGroup
} from "@blueprintjs/core";
import DefaultToaster from "../../../atoms/DefaultToaster";
import classNames from "classnames";
import styles from "./ShareVideo.module.scss";
import { getDimensions } from "./helper";

export default function EmbedTab({ videoId, videoUrl }) {
  const [embedType, setEmbedType] = useState("Fixed");
  const [height, setHeight] = useState("600");
  const [width, setWidth] = useState("960");
  const [aspectRatio, setAspectRatio] = useState(56.25);

  useEffect(() => {
    isNaN(parseInt(height)) && setHeight("");
    isNaN(parseInt(width)) && setWidth("");
  }, [height, width]);

  getDimensions(videoUrl).then(({ ratio }) => {
    if (ratio < 100) {
      setAspectRatio(ratio);
    } else {
      setAspectRatio(100);
    }
  });

  const videoSrc = `${process.env.REACT_APP_WEB_URL}/watch/${videoId}`;

  const embedCode = `<iframe width="${width || 960}" height="${height ||
    600}" src="${videoSrc}" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>`;

  const responsiveEmbedCode =
    `<div style="padding:${aspectRatio}% 0 0 0;position:relative;">` +
    `<iframe style="position:absolute;top:0;left:0;width:100%;height:100%;min-height:400px;" ` +
    `src="${videoSrc}" ` +
    `frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>` +
    `</div>`;

  const inputRef = useRef(null);

  function selectAllText() {
    if (!inputRef.current) return;
    inputRef.current.select();
  }

  function copyToClipboard() {
    selectAllText();
    document.execCommand("copy");

    DefaultToaster.show({
      message: "Video code copied to clipboard.",
      icon: "tick-circle",
      timeout: 1000
    });
  }

  return (
    <div>
      <FormGroup
        label="Code"
        helperText="Copy and paste this code on your blog or website to embed the video."
      >
        <textarea
          className={classNames(Classes.INPUT, Classes.FILL)}
          value={embedType === "Fixed" ? embedCode : responsiveEmbedCode}
          onClick={selectAllText}
          ref={inputRef}
        />
        <RadioGroup
          inline
          onChange={(event) => setEmbedType(event.currentTarget.value)}
          selectedValue={embedType}
        >
          <Radio label="Fixed" value="Fixed" />
          <Radio label="Responsive" value="Responsive" />
        </RadioGroup>
        {embedType === "Fixed" && (
          <div className={styles.fixedVideoOptions}>
            <InputGroup
              className={styles.optionInput}
              value={width}
              onChange={({ target: { value } }) => setWidth(parseInt(value))}
              placeholder="960"
            ></InputGroup>
            <span>x</span>
            <InputGroup
              className={styles.optionInput}
              value={height}
              onChange={({ target: { value } }) => setHeight(parseInt(value))}
              placeholder="600"
            ></InputGroup>
          </div>
        )}
      </FormGroup>

      <Button
        text="Copy to Clipboard"
        icon="clipboard"
        onClick={copyToClipboard}
      />
    </div>
  );
}
